import React, { Component } from "react";
import $ from "jquery";
import * as Common from "../CommonControlls/CommonJs";
import MainLayout from "../CommonControlls/MainLayout";
import Topmenu from "../CommonControlls/Topmenubar";
import { connect } from "react-redux";
import Table from "../CommonControlls/TableRendrer";
import { Link } from "react-router-dom";
import AlertModal from "../CommonControlls/AlertModal";
import DropDown from "../CommonControlls/DropdownRendrer";
import StarRatings from "react-star-ratings";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from "jspdf";
import _ from "lodash";

const mapStateToProps = (store) => {
    return store;
};

const mapDispatchToProps = (dispatch) => {
    return {
        ShowAlert: (Settings) => {
            dispatch({ type: "UpdateAlert", payload: Settings });
        },
        ShowLoader: (Isloading) => {
            dispatch({ type: "UpdateLoader", payload: Isloading });
        },
    };
};

class Assignments_List extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Table
            data: [],
            page: 1,
            csvFileLink: '',
            sizePerPage: 15,
            TotalRecord: 0,
            loading: false,
            exportLoading: false,

            sortField: "id",
            idsortOrder: "desc",
            provinceNamesortOrder: "",
            districtNamesortOrder: "",
            creationDateTimesortOrder: "",
            amountsortOrder: "",
            filterByCompletionDate: false,

            permissions: [],

            startDate: new Date(),
            endDate: new Date(),

            RiderLoader: false,
            Riderslist: [],
            RiderId: 0,

            rating: 0,
            assignmentId: 0,

            Ratinglist: [
                { id: 1, name: "1 Star" },
                { id: 2, name: "2 Stars" },
                { id: 3, name: "3 Stars" },
                {
                    id: 4,
                    name: "4 Stars",
                },
                { id: 5, name: "5 Stars" },
            ],
            RatingId: 0,

            Statuslist: [
                { id: 1, name: "Not assigned" },
                { id: 2, name: "Not started yet" },
                { id: 3, name: "In progress" },
                { id: 4, name: "Completed" },
                { id: 6, name: "Rejected" },
            ],
            StatusId: 0,

            SrList: [],
            FilteredSrs: [],
            SrId: [],

            alertModalData: {
                title: "",
                message: "",
                First_Callback: () => { },
                Second_Callback: () => { },
                type: 1,
            },

            HCFlist: [],
            XpertSitelist: [],
            processedHCF: [],
            processedXpertsite: [],

            ProvinceLoader: false,
            Provincelist: [],
            ProvinceId: [],

            DistrictLoader: false,
            Districtlist: [],
            FilteredDistrictlist: [],

            FilteredRiders: [],
            DistrictId: [],
        };
    }

    HandleDateChange = (Field, date) => {
        this.setState(
            { [Field]: date === "" || date == null ? new Date() : date },
            () => {
                if (
                    Field === "startDate" &&
                    this.state.startDate > this.state.endDate
                ) {
                    this.setState({ endDate: this.state.startDate });
                }
            }
        );
    };
    HandleAutoSuggestValChange = (fieldId, value) => {
        this.setState(
            {
                [fieldId]: value,
                // isSaveSearch: this.state.isSearchChanged ? true : false
            },
            () => {
                if (fieldId === "ProvinceId") {
                    this.FilterDistricts(value);
                }
                if (fieldId === "DistrictId") {
                    var selectedDistricts =
                        value.length === 0
                            ? ""
                            : "," + Common.convertToCommaString(value, "id") + ",";

                    this.SelectRiders(selectedDistricts);
                }
                if (fieldId === "SrId") {
                    var selectedSrs = this.state.SrId;
                    const tempDistricts = this.state.Districtlist;
                    var filteredSrsId = Common.ConvertToCommaSplitArray(
                        selectedSrs,
                        "id"
                    );
                    var filteredSelectedDistricts = tempDistricts.filter(function (obj) {
                        return filteredSrsId.indexOf(obj.subrecipientid) > -1;
                    });
                    this.setState({
                        FilteredDistrictlist: filteredSelectedDistricts,
                    });
                }
            }
        );
    };
    FilterDistricts = (value) => {
        // filter ditrict list
        // var TempArr = this.state.Districtlist
        var selectedProvince = Common.ConvertToCommaSplitArray(value, "id");
        // var filteredDistrictList = TempArr.filter(function (obj) {
        //     return selectedProvince.indexOf(obj.provinceId) > -1
        // });

        // filter district selected values
        // var selectedDistricts = this.state.DistrictId
        // var filteredDistrictIdArr = Common.ConvertToCommaSplitArray(filteredDistrictList, "id")
        // var filteredSelectedDistricts = selectedDistricts.filter(function (obj) {
        //     return filteredDistrictIdArr.indexOf(obj.id) > -1
        // });

        const TempSr = this.state.SrList;
        const filtered = TempSr.filter((el) => {
            return selectedProvince.indexOf(el.provinceid) > -1;
        });

        this.setState({
            // FilteredDistrictlist: filteredDistrictList,
            // DistrictId: filteredSelectedDistricts,
            FilteredSrs: filtered,
        });
    };

    changeRating = (newRating, name) => {
        this.setState({
            rating: newRating,
        });
    };

    render() {
        const Tags = [
            "Samples delivered in good shape",
            "Samples delivered in bad shape",
            "labels were damaged",
            "labels were fine",
        ];

        const CellMenu = (cell, row) => {
            return (
                <div key={ row.id }>
                    <button
                        onClick={() => {
                            this.ResetRatingModel(row.id);
                        }}
                        data-toggle="tooltip"
                        title="Enter Status"
                        className="btn TableRow_btn"
                    >
                        <i className="fa fa-file-text-o text-primary" aria-hidden="true"></i>
                    </button>

                    <span>
                        <button
                            hidden={row.isRejected !== true}
                            onClick={() => {
                                this.RegenerateAssignment(row.id);
                            }}
                            data-toggle="tooltip"
                            title="Re-Activate Job"
                            className="btn TableRow_btn"
                        >
                            <i className="fa fa-repeat" aria-hidden="true"></i>
                        </button>

                        {this.state.permissions.includes("riderjobs-delete") &&
                            row.status >= 5 && (
                                <button
                                    onClick={() => {
                                        this.onDelete(row.id);
                                    }}
                                    data-toggle="tooltip"
                                    title="Delete Job"
                                    className="btn TableRow_btn"
                                >
                                    <i className="fa fa-trash text-danger" aria-hidden="true"></i>
                                </button>
                            )}
                    </span>
                </div>
            );
        };

        function avatarformatter(cell, row) {
            return <span>{row.RiderName}</span>;
        }

        function Ratingformatter(cell, row) {
            return cell == null || cell === "" ? "" : <span>{cell + " Stars"}</span>;

            // <span>
            //      <StarRatings
            //         rating={cell}
            //         starRatedColor="rgb(230, 67, 47)"
            //         numberOfStars={5}
            //         name='rating'
            //         starDimension='20px'
            //     />
            // </span>
        }

        function RoutLocationformatter(routList) {
            for (var i in routList) {
                if (routList[i].isRiderOnLocation === true) {
                    return "At " + routList[i].locationName;
                }
            }
        }

        function TotalSamplesformatter(routList) {
            var count = 0;
            for (var i in routList) {
                if (routList[i].samplesCount != null)
                    count = count + routList[i].samplesCount;
            }
            return count;
        }

        function CollectedSamplesformatter(samplesList) {
            var count = 0;
            for (var i in samplesList) {
                if (samplesList[i].deliveryStatus > 2)
                    count = count + 1;
            }
            return count;
        }

        const PickupFormatterNew = (cell, row) => {
            // Split the input text into individual words
            const words = row.pickUpName?.split(', ');

            // Map the words to JSX elements with <span> tags
            const wordsWithSpans = words?.map((word, index) => (
                <li key={index}>{word}</li>
            ));

            return <ol className="pickUpNames">{wordsWithSpans}</ol>;
        };

        const PickupFormatter = (cell, row) => {
            let pickups = "";
            if (row.obj.length > 1) {
                for (let i = 0; i <= row.obj.length; i++) {
                    if (i + 1 < row.obj.length) {
                        if (row.obj[i] !== undefined) {
                            pickups += row.obj[i]?.locationName + ", ";
                        }
                    }
                }
            } else {
                pickups = row.obj[0]?.locationName + ", ";
            }
            return pickups;
        };

        function PickupRoutformatter(cell, row) {
            var processedrout = Common.ProcessDataInArray(row.obj, "locationId");
            var firstLocation = null;
            var secondLocation = null;

            if (row.riderWayToId !== null || row.riderWayToId !== 0) {
            }

            // var count=0
            // for(var i in samplesList)
            // {
            //     if(samplesList[i].deliveryStatus > 2)
            //     count=count + 1
            // }
            // return count
        }

        const columns = [
            {
                dataField: "provinceName",
                text: "Province",
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "110px", fontSize: "13px" };
                },
                csvExport: true,
            },
            {
                dataField: "subRecipient_ShortName",
                text: "Sr. Name",
                headerStyle: () => {
                    return { fontSize: "13px", width: "100px" };
                },
                sort: true,
            },
            {
                dataField: "districtName",
                text: "District",
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "100px", fontSize: "13px" };
                },
                csvExport: true,
            },

            {
                dataField: "id",
                text: "Job #",
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "75px", fontSize: "13px" };
                },
            },

            {
                dataField: "hcfClusterId",
                text: "HcfClusterId",
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "75px", fontSize: "13px" };
                },
            },
            {
                dataField: "creationDateTime",
                text: "Creation Date",
                headerStyle: (colum, colIndex) => {
                    return { width: "115px", fontSize: "13px" };
                },
                formatter: (cell, row) => {
                    return Common.ConvertToLocalDate(cell)
                },
                csvFormatter: (creationDateTime) =>
                    Common.ConvertToLocalDate(creationDateTime),
                sort: true,
            },
            {
                dataField: "creationDateTime",
                text: "Creation Time",
                headerStyle: (colum, colIndex) => {
                    return { width: "115px", fontSize: "13px" };
                },
                formatter: (cell, row) => {
                    return Common.ConvertToLocalTime(cell)
                },
                csvFormatter: (creationDateTime) =>
                    Common.ConvertToLocalTime(creationDateTime),
                sort: true,
            },
            {
                dataField: "completionDateTime",
                text: "Completion Date",
                headerStyle: (colum, colIndex) => {
                    return { width: "115px", fontSize: "13px" };
                },
                formatter: (cell, row) => {
                    return Common.ConvertToLocalDate(cell)
                },
                csvFormatter: (completionDateTime) =>
                    Common.ConvertToLocalDate(completionDateTime),
                sort: true,
            },
            {
                dataField: "completionDateTime",
                text: "Completion Time",
                headerStyle: (colum, colIndex) => {
                    return { width: "115px", fontSize: "13px" };
                },
                formatter: (cell, row) => {
                    return Common.ConvertToLocalTime(cell)
                },
                csvFormatter: (completionDateTime) =>
                    Common.ConvertToLocalTime(completionDateTime),
                sort: true,
            },
            {
                dataField: "riderName",
                text: "Rider",

                headerStyle: (colum, colIndex) => {
                    return { width: "125px", fontSize: "13px" };
                },
                // sort: true,
            },
            {
                dataField: "riderType",
                text: "Rider Type",

                headerStyle: (colum, colIndex) => {
                    return { width: "125px", fontSize: "13px" };
                },
                // sort: true,
            },
            {
                dataField: "riderPhone",
                text: "Rider Contact",
                // formatter: (cell, row)=>{ return avatarformatter(cell, row)},
                hidden: false,
                headerStyle: (colum, colIndex) => {
                    return { width: "115px", fontSize: "13px" };
                },
                // sort: true,
            },
            {
                dataField: "amount",
                text: "Amount",
                sort: true,
                formatter: (cell, row) => {
                    return cell.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                },
                headerStyle: (colum, colIndex) => {
                    return { width: "100px", fontSize: "13px" };
                },
                csvExport: true,
            },
            {
                dataField: "rideType",
                text: "Ride Type",

                headerStyle: (colum, colIndex) => {
                    return { width: "125px", fontSize: "13px" };
                },
                // sort: true,
            },
            {
                dataField: "distance",
                text: "Distance",

                headerStyle: (colum, colIndex) => {
                    return { width: "125px", fontSize: "13px" };
                },
                // sort: true,
            },

            {
                dataField: "status",
                text: "Status",
                // sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "150px", fontSize: "13px" };
                },
                formatter: (cell, row) => {
                    
                    return (
                        <span>
                            {row.isRejected
                                ? "Expired"
                                : row.expireCount > 0 && row.status === 1
                                    ? row.expireCount + " re-attempt(s)"
                                    : cell === 1
                                        ? "Not accepted yet"
                                        : cell === 2
                                            ? "Not started yet"
                                            : cell === 3
                                                ? "In progress"
                                                : cell === 4 || cell === 5
                                                    ? "Completed"
                                                    : ""}
                        </span>
                    );
                },
                csvFormatter: (cell, row) =>
                    row.isRejected
                        ? "Expired"
                        : row.expireCount > 0 && row.status === 1
                            ? row.expireCount + " re-attempt(s)"
                            : cell === 1
                                ? "Not accepted yet"
                                : cell === 2
                                    ? "Not started yet"
                                    : cell === 3
                                        ? "In progress"
                                        : cell === 4 || cell === 5
                                            ? "Completed"
                                            : "",
            },
            {
                dataField: "pickUpName",
                text: "Pickups",
                headerStyle: () => {
                    return { width: "275px", fontSize: "13px" };
                },
                formatter: (cell, row) => {
                    return PickupFormatterNew(cell, row);
                }
            },
            // ,{
            //     dataField: '',
            //     text: 'Pickup rout wt samples',
            //     // sort: true,
            //     headerStyle: (colum, colIndex) => {return { width: '200px' }},
            //     formatter:(cell, row)=>{return <span>{
            //         row.status==3? row.riderWayToId==null?
            //         RoutLocationformatter(row.obj)
            //         : "Way to " +(row.riderWayToIdType==1 || row.riderWayToIdType==2 ? this.state.processedHCF[row.riderWayToId].name : this.state.processedXpertsite[row.riderWayToId].name)
            //         : ""
            //     }</span>},
            //     csvFormatter:(cell, row) => (  row.status==3? row.riderWayToId==null?
            //         RoutLocationformatter(row.obj)
            //         : "Way to " +(row.riderWayToIdType==1 || row.riderWayToIdType==2 ? this.state.processedHCF[row.riderWayToId].name : this.state.processedXpertsite[row.riderWayToId].name)
            //         : "" ),
            // }
            {
                dataField: "destinationName",
                text: "Destination",
                // sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "175px", fontSize: "13px" };
                },
                formatter: (cell, row) => {
                    //return <span>{row.obj[row.obj.length - 1]?.locationName}</span>;
                    return <span>{row.destinationName}</span>;
                },
                //csvFormatter: (cell, row) => row.obj[row.obj.length - 1]?.locationName,
                csvFormatter: (cell, row) => row.destinationName,
            },
            {
                dataField: "deliveredSamplesCount",
                text: "Collected",
                headerStyle: (colum, colIndex) => {
                    return { width: "121px", fontSize: "13px" };
                }
            },
            {
                dataField: "samplesCount",
                text: "Total Samples",
                headerStyle: (colum, colIndex) => {
                    return { width: "121px", fontSize: "13px" };
                }
            },
            {
                dataField: "starRating",
                text: "Rating",
                // sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "70px", fontSize: "13px" };
                },
                formatter: (cell, row) => {
                    return Ratingformatter(cell, row);
                },
                csvFormatter: (cell, row) =>
                    cell == null || cell === "" ? "" : cell + " Stars",
            },
            {
                dataField: "comments",
                text: "Comments",
                // sort: true,
                headerStyle: (colum, colIndex) => {
                    return { width: "95px", fontSize: "13px" };
                },
                csvFormatter: (cell, row) => (cell == null || cell === "" ? "" : cell),
            },
            {
                dataField: "",
                text: "Actions",
                headerStyle: (colum, colIndex) => {
                    return { width: "75px" };
                },
                formatter: (cell, row) => {
                    return CellMenu(cell, row);
                },
                csvExport: false,
            },
        ];

        return (
            <div>
                
                {/* -------------------Rider Feedback-------- */}
                <button
                    id="StarRatingModal_btn"
                    style={{ display: "none" }}
                    type="button"
                    className="btn btn-primary"
                    data-toggle="modal"
                    data-target="#StarRating_Modal"
                >
                    Large modal
                </button>
                <div
                    className="modal fade"
                    id="StarRating_Modal"
                    tabIndex="-1"
                    role="dialog"
                    aria-labelledby="addappTitle"
                    aria-hidden="true"
                >
                    <div
                        className="modal-dialog modal-dialog-centered"
                        role="document"
                        style={{ maxWidth: "500px" }}
                    >
                        <div className="modal-content">
                            <div className="modal-header">
                                <div className="ModalTopClose_btn">
                                    <span
                                        style={{ cursor: "pointer" }}
                                        data-dismiss="modal"
                                        aria-hidden="true"
                                    >
                                        x
                                    </span>
                                </div>
                                <h5
                                    className="modal-title"
                                    style={{ fontSize: "17px", fontWeight: "700" }}
                                >
                                    Provide feedback on the job
                                </h5>
                                {/* <i className="fa fa-times-circle appointmentdetailcross" data-dismiss="modal" aria-hidden="true"></i> */}
                            </div>

                            <div className="modal-body">
                                <form onSubmit={this.SaveRiderFeedBack} noValidate>
                                    <div
                                        className="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12"
                                        style={{
                                            marginTop: "20px",
                                            marginBottom: "30px",
                                            paddingBottom: "20px",
                                            borderBottom: "1px solid #ced4da",
                                        }}
                                    >
                                        <label htmlFor="">How efficient rider was?</label>
                                        <StarRatings
                                            rating={this.state.rating}
                                            starRatedColor="rgb(230, 67, 47)"
                                            changeRating={this.changeRating}
                                            numberOfStars={5}
                                            name="rating"
                                        />
                                    </div>

                                    <div className="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <label htmlFor="">Tags</label>
                                        <div
                                            className="col-lg-12 col-md-12 col-sm-12 col-xs-12 row"
                                            style={{ padding: "0px" }}
                                        >
                                            {Tags.map((item, index) => {
                                                return (
                                                    <div
                                                        onClick={(e) => {
                                                            this.selectFeedbackTag(e, item);
                                                        }}
                                                        className="Tag_item"
                                                        key={index}
                                                    >
                                                        {item}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>

                                    <div className="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <label htmlFor="">Comments</label>
                                        <textarea
                                            className="form-control"
                                            id="Rider_Comments"
                                            rows="3"
                                        ></textarea>
                                    </div>

                                    <div
                                        style={{
                                            float: "right",
                                            marginRight: "15px",
                                            marginTop: "35px",
                                        }}
                                    >
                                        <button
                                            type="button"
                                            className="btn btn_style3"
                                            data-dismiss="modal"
                                            aria-hidden="true"
                                        >
                                            CANCEL
                                        </button>
                                        <button type="submit" className="btn btn_style1">
                                            SAVE
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <AlertModal {...this.state.alertModalData} />
                <MainLayout />
                <div id="right-panel" className="right-panel">
                    <Topmenu
                        PageTitle="Rider Jobs"
                        isShowAddBtn={false}
                        AddBtnLabel=""
                        AddBtnLink=""
                    />
                    <div className="content">
                        <div
                            className="card"
                            style={{
                                marginBottom: "20px",
                                background: "none",
                                boxShadow: "none",
                            }}
                            hidden={
                                this.props.UserAuthentication.UserInfo?.roleId === 1 ||
                                    this.props.UserAuthentication.UserInfo?.roleId === 8
                                    ? false
                                    : true
                            }
                        >
                            <div className="card-body row" style={{ padding: "0px" }}>
                                <div className="widget-tabs-list">
                                    <ul className="Cases-nav nav nav-tabs">
                                        {this.state.permissions.includes("jobhistory-view") && (
                                            <li>
                                                <Link to="/Jobs" className="active show">
                                                    Job History
                                                </Link>
                                            </li>
                                        )}
                                        {this.state.permissions.includes("riderprofiles-view") && (
                                            <li>
                                                <Link to="/RiderProfiles">
                                                    Rider Profiles
                                                </Link>
                                            </li>
                                        )}
                                    </ul>
                                </div>
                            </div>
                        </div>

                        {this.state.permissions.includes("jobhistory-view") && (
                            <div className="card">
                                <div className="card-body">
                                    <div className="Table_Search row">
                                        <div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                            <label htmlFor="">Province</label>
                                            <DropDown
                                                multi={true}
                                                dropdownRenderer={true}
                                                create={false}
                                                onChange={this.HandleAutoSuggestValChange}
                                                Type="ProvinceId"
                                                options={this.state.Provincelist}
                                                val={this.state.ProvinceId}
                                                addPlaceholder=""
                                                disabled={false}
                                                loading={this.state.ProvinceLoader}
                                                searchBy="name"
                                                labelField="name"
                                                valueField="id"
                                                contentRenderer={true}
                                                placeholder="Select"
                                            />
                                        </div>

                                        <div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                            <label htmlFor="">Sub Recipient</label>
                                            <DropDown
                                                ValueType={false}
                                                multi={true}
                                                dropdownRenderer={true}
                                                create={false}
                                                onChange={this.HandleAutoSuggestValChange}
                                                Type="SrId"
                                                options={this.state.FilteredSrs}
                                                val={this.state.SrId}
                                                addPlaceholder=""
                                                disabled={false}
                                                searchBy="name"
                                                labelField="name"
                                                valueField="id"
                                                contentRenderer={true}
                                                placeholder="Select"
                                            />
                                        </div>

                                        <div className="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                            <label htmlFor="">District</label>
                                            <DropDown
                                                multi={true}
                                                dropdownRenderer={true}
                                                create={false}
                                                onChange={this.HandleAutoSuggestValChange}
                                                Type="DistrictId"
                                                options={this.state.FilteredDistrictlist}
                                                val={this.state.DistrictId}
                                                addPlaceholder=""
                                                disabled={false}
                                                loading={this.state.DistrictLoader}
                                                searchBy="name"
                                                labelField="name"
                                                valueField="id"
                                                contentRenderer={true}
                                                placeholder="Select"
                                            />
                                        </div>

                                        <div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                            <label htmlFor="">Job ID</label>
                                            <input
                                                autoComplete="off"
                                                type="text"
                                                className="form-control Search_InputField"
                                                id="SearchId"
                                                placeholder="Job #"
                                            />
                                        </div>

                                        <div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                            <label htmlFor="">Rider</label>
                                            <DropDown
                                                ValueType={false}
                                                multi={false}
                                                dropdownRenderer={false}
                                                create={false}
                                                onChange={this.HandleAutoSuggestValChange}
                                                Type="RiderId"
                                                options={this.state.FilteredRiders}
                                                val={this.state.RiderId}
                                                addPlaceholder=""
                                                disabled={false}
                                                loading={this.state.RiderLoader}
                                                searchBy="name"
                                                labelField="name"
                                                valueField="id"
                                                contentRenderer={false}
                                                placeholder="Select"
                                            />
                                        </div>

                                        <div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                            <label htmlFor="">Rating</label>
                                            <DropDown
                                                multi={false}
                                                dropdownRenderer={false}
                                                create={false}
                                                onChange={this.HandleAutoSuggestValChange}
                                                Type="RatingId"
                                                options={this.state.Ratinglist}
                                                val={this.state.RatingId}
                                                addPlaceholder=""
                                                disabled={false}
                                                loading={false}
                                                searchBy="name"
                                                labelField="name"
                                                valueField="id"
                                                contentRenderer={false}
                                                placeholder="Select"
                                            />
                                        </div>

                                        <div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                            <label htmlFor="">Status</label>
                                            <DropDown
                                                multi={false}
                                                dropdownRenderer={false}
                                                create={false}
                                                onChange={this.HandleAutoSuggestValChange}
                                                Type="StatusId"
                                                options={this.state.Statuslist}
                                                val={this.state.StatusId}
                                                addPlaceholder=""
                                                disabled={false}
                                                loading={false}
                                                searchBy="name"
                                                labelField="name"
                                                valueField="id"
                                                contentRenderer={false}
                                                placeholder="Select"
                                            />
                                        </div>
                                        <div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                            <label htmlFor="">From</label>
                                            <DatePicker
                                                selected={this.state.startDate}
                                                onChange={(date) => {
                                                    this.HandleDateChange("startDate", date);
                                                }}
                                                peekNextMonth
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                            />
                                        </div>

                                        <div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                            <label htmlFor="">To</label>
                                            <DatePicker
                                                selected={this.state.endDate}
                                                onChange={(date) => {
                                                    this.HandleDateChange("endDate", date);
                                                }}
                                                peekNextMonth
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                minDate={this.state.startDate}
                                            />
                                        </div>

                                        <div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                            <label htmlFor="">Search By</label>
                                            <input
                                                autoComplete="off"
                                                type="text"
                                                className="form-control Search_InputField"
                                                id="SearchBy"
                                                placeholder="Search By"
                                            />
                                        </div>

                                        <div className="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                            <label
                                                className="checkboxesinputs"
                                                style={{
                                                    position: "relative",
                                                    marginTop: 45,
                                                    marginRight: 10,
                                                }}
                                            >
                                                <input
                                                    className="NodeCheckbox_input"
                                                    type="checkbox"
                                                    checked={this.state.filterByCompletionDate}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            filterByCompletionDate: e.target.checked,
                                                        });
                                                    }}
                                                />
                                                <span className="checkmark"></span>
                                                <span
                                                    style={{
                                                        fontWeight: "100",
                                                        color: "black",
                                                    }}
                                                >
                                                    Filter by Completion Date
                                                </span>
                                            </label>
                                            <button
                                                style={{ position: "relative", marginTop: 35 }}
                                                onClick={() => {
                                                    this.PopulateTable();
                                                }}
                                                id="FormSearchBtn"
                                                className={
                                                    this.props.UserAuthentication?.UserInfo?.roleId ===
                                                        1 ||
                                                        this.props.UserAuthentication?.UserInfo?.roleId === 8
                                                        ? "btn btn-primary"
                                                        : "btn btn_style1"
                                                }
                                            >
                                                Search
                                            </button>
                                        </div>
                                    </div>

                                    {this.state.csvFileLink && (
                                        <p>
                                            <a id="btnDownload" href={this.state.csvFileLink} download="sheet.csv">
                                                Download CSV File
                                            </a>
                                        </p>
                                    )}

                                    <Table
                                        keyField="id"
                                        data={this.state.data}
                                        page={this.state.page}
                                        sizePerPage={this.state.sizePerPage}
                                        totalSize={this.state.TotalRecord}
                                        onTableChange={this.handleTableChange}
                                        changeSizePerPage={(size) => {
                                            setTimeout(() => {
                                                this.ExportData();
                                            }, 200);
                                        }}
                                        exportAllowed={this.state.permissions.includes(
                                            "jobhistory-export"
                                        )}
                                        isPagination={true}
                                        columns={columns}
                                        exportLoading={this.state.exportLoading}
                                        exportPdf={this.ExportPdf}
                                        loading={this.state.loading}
                                        RefreshTable={this.PopulateTable}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    componentWillMount() {
        if (this.props.UserAuthentication.AuthToken === "") {
            this.props.history.push("/Login");
        }
    }

    componentDidMount() {
        Common.AddClassToMenueLink("MenuLink_Assignments");
        this.GetPageConfigData(() => {
            this.PopulateTable();
        });
        $(".Search_InputField").on("keypress", (e) => {
            if (e.which === 13) {
                this.PopulateTable();
            }
        });
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "Get",
            false,
            Common.APILinks.SelectAll_RolesPermissions,
            {
                pageSize: 15,
                pageNumber: 1,
            },
            (resp) => {
                const modifiedPermissions = resp.data
                    .filter(
                        (p) => p.permissioN_GROUP === "RiderJobs" && p.permissioN_ALLOWED
                    )
                    .map((d) => d.permissioN_NAME);
                this.setState({ permissions: modifiedPermissions });
            }
        );

        this.SelectSubReciepents();
        //this.SelectRiders();
    }

    SelectSubReciepents = () => {
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "GET",
            false,
            Common.APILinks.SelectALl_SubRecipient,
            {},
            (resp) => {
                if (resp.status) {
                    this.setState({
                        SrList: resp.data.map((d) => ({
                            id: d.id,
                            name: d.short_name,
                            ...d,
                        })),
                    });
                }
            }
        );
    };
    GetPageConfigData = (CallBack) => {
        this.props.ShowLoader({ Isloading: true });
        var d1 = $.Deferred();
        var d2 = $.Deferred();
        var d3 = $.Deferred();
        var d4 = $.Deferred();
        var d5 = $.Deferred();

        // this.SelectRiders(() => {
        // 	d1.resolve();
        // });
        this.SelectXpertSites(() => {
            d2.resolve();
        });
        this.SelectHCF(() => {
            d3.resolve();
        });
        this.SelectProvinces(() => {
            d4.resolve();
        });
        this.SelectDistricts(() => {
            d5.resolve();
        });
        $.when(d2, d3, d4, d5).done(() => {
            this.props.ShowLoader({ Isloading: false });
            CallBack();
        });
    };
    SelectRiders = (districtId) => {
        const provinceId =
            this.state.ProvinceId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.ProvinceId, "id") + ",";

        const params = {
            districtId,
            provinceId,
            sortField: "id",
            sortOrder: "asc",
            pageNumber: 1,
            pageSize: 200,
        };

        this.setState({ RiderLoader: true });
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "GET",
            false,
            Common.APILinks.Select_MultipleRiderProfiles,
            params,
            (resp) => {
                const tempRiders = resp.data;
                const filtered = tempRiders.filter((el) => {
                    return districtId.indexOf(el.districtId) > -1;
                });
                this.setState({
                    FilteredRiders: filtered,
                    Riderslist: resp.data,
                    RiderLoader: false,
                });
            },
            (error) => {
                this.setState({
                    RiderLoader: false,
                });
                this.props.ShowAlert({ Type: 0, Msg: error });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
            }
        );
    };
    SelectXpertSites = (Callback) => {
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "GET",
            false,
            Common.APILinks.SelectAll_XpertSites,
            {},
            (data) => {
                var processedXpertsite = Common.ProcessDataInArray(data.data, "id");
                this.setState({
                    XpertSitelist: data.data,
                    processedXpertsite: processedXpertsite,
                });
                Callback();
            },
            (error) => {
                this.props.ShowAlert({ Type: 0, Msg: error });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
                Callback();
            }
        );
    };
    SelectHCF = (Callback) => {
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "GET",
            false,
            Common.APILinks.SelectAll_HCF,
            {},
            (data) => {
                var processedHCF = Common.ProcessDataInArray(data.data, "id");
                this.setState({
                    HCFlist: data.data,
                    processedHCF: processedHCF,
                });
                Callback();
            },
            (error) => {
                this.props.ShowAlert({ Type: 0, Msg: error });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
                Callback();
            }
        );
    };
    SelectProvinces = (Callback) => {
        this.setState({ ProvinceLoader: true });
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "GET",
            false,
            Common.APILinks.SelectAll_Province,
            {},
            (data) => {
                this.setState({
                    ProvinceLoader: false,
                    Provincelist: data.data,
                });
                Callback();
            },
            (error) => {
                this.setState({ ProvinceLoader: false });
                this.props.ShowAlert({ Type: 0, Msg: error });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
                Callback();
            }
        );
    };
    SelectDistricts = (Callback) => {
        this.setState({ DistrictLoader: true });
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "GET",
            false,
            Common.APILinks.SelectAll_District,
            {},
            (data) => {
                this.setState({
                    DistrictLoader: false,
                    Districtlist: data.data,
                });
                Callback();
            },
            (error) => {
                this.setState({ DistrictLoader: false });
                this.props.ShowAlert({ Type: 0, Msg: error });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
                Callback();
            }
        );
    };
    handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
        if (type === "sort") {
            let tempFieldorderLabel = sortField + "sortOrder";
            let tempFieldorder =
                this.state[tempFieldorderLabel] === ""
                    ? sortOrder
                    : this.state[tempFieldorderLabel] === "asc"
                        ? "desc"
                        : "asc";
            this.setState(
                {
                    sortField,
                    [tempFieldorderLabel]: tempFieldorder,
                },
                () => {
                    this.PopulateTable();
                }
            );
            return;

            // let result = this.state.data
            // // Handle column sort
            // if (sortOrder === 'asc') {
            //     result = result.sort((a, b) => {
            //     if (a[sortField] > b[sortField]) {
            //         return 1;
            //     } else if (b[sortField] > a[sortField]) {
            //         return -1;
            //     }
            //     return 0;
            //     });
            // } else {
            //     result = result.sort((a, b) => {
            //     if (a[sortField] > b[sortField]) {
            //         return -1;
            //     } else if (b[sortField] > a[sortField]) {
            //         return 1;
            //     }
            //     return 0;
            //     });
            // }
            // return
        }
        this.setState(
            {
                page,
                sizePerPage,
            },
            () => {
                this.PopulateTable();
            }
        );
    };
    ExportPdf = () => {
        const doc = new jsPDF();

        var provinceIdString =
            this.state.ProvinceId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.ProvinceId, "id") + ",";
        var districtIdString =
            this.state.DistrictId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.DistrictId, "id") + ",";
        var subRecipientIdString =
            this.state.SrId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.SrId, "id") + ",";

        var Parameters = {
            assignmentId: $("#SearchId").val(),
            RiderInfo: $("#SearchBy").val(),
            riderId: this.state.RiderId,
            rating: this.state.RatingId,
            statusId: this.state.StatusId,
            pageSize: this.state.TotalRecord,
            pageNumber: this.state.page,
            filterByCompletionDate: this.state.filterByCompletionDate,
            srDistrictIds: this.props.UserAuthentication?.UserInfo?.srDistrictIds,
            fromDate:
                this.state.startDate == null || this.state.startDate === ""
                    ? null
                    : Common.ConvertToUtcDateTimeNew(
                        Common.getOnlyDate(this.state.startDate) + " 00:00:00"
                    ),
            toDate:
                this.state.endDate == null || this.state.endDate === ""
                    ? null
                    : Common.ConvertToUtcDateTimeNew(
                        Common.getOnlyDate(this.state.endDate) + " 23:59:59"
                    ),
            provinceIdString,
            districtIdString,
            subrecipientId: subRecipientIdString,
            sortField: this.state.sortField,
            sortOrder: this.state[this.state.sortField + "sortOrder"],
        };
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "Get",
            false,
            this.props.UserAuthentication?.UserInfo?.roleId === 1 ||
                this.props.UserAuthentication?.UserInfo?.roleId === 7
                ? Common.APILinks.Select_AllAssignments
                : this.props.UserAuthentication?.UserInfo?.roleId === 6
                    ? Common.APILinks.Select_BHUAssignments
                    : this.props.UserAuthentication?.UserInfo?.roleId === 7
                        ? Common.APILinks.Select_RHCAssignments
                        : Common.APILinks.Select_DestinationAssignments,
            Parameters,
            (resp) => {
                $("#FormSearchBtn").prop("disabled", false);
                this.setState({ loading: false });
                if (resp.status) {
                    doc.autoTable({
                        theme: "grid",
                        body: [...resp.data],
                        columns: [
                            { header: "id", dataKey: "id" },
                            { header: "Rider", dataKey: "riderName" },
                            // {header: 'Contact', dataKey: 'riderContact'},
                            // {header: 'Category', dataKey: 'category'},
                            { header: "Sr, Name", dataKey: "subRecipient_ShortName" },
                            { header: "Amount", dataKey: "amount" },
                            { header: "Status", dataKey: "status" },
                            { header: "Province", dataKey: "provinceName" },
                            { header: "District", dataKey: "districtName" },
                            { header: "Tehsil", dataKey: "tehsilName" },
                        ],
                    });

                    doc.save("RiderJobs.pdf");
                }
            },
            (error) => {
                $("#FormSearchBtn").prop("disabled", false);
                this.setState({ loading: false });
                this.props.ShowAlert({
                    Type: 0,
                    Msg: "Something went wrong, please try again.",
                });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
            }
        );
    };
    ExportData = () => {
        $("#FormSearchBtn").prop("disabled", true);
        this.setState({ exportLoading: true, loading: true });

        var provinceIdString =
            this.state.ProvinceId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.ProvinceId, "id") + ",";
        var districtIdString =
            this.state.DistrictId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.DistrictId, "id") + ",";
        var subRecipientIdString =
            this.state.SrId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.SrId, "id") + ",";

        var Parameters = {
            assignmentId: $("#SearchId").val(),
            RiderInfo: $("#SearchBy").val(),
            riderId: this.state.RiderId,
            rating: this.state.RatingId,
            statusId: this.state.StatusId,
            pageSize: this.state.TotalRecord,
            pageNumber: 1,
            filterByCompletionDate: this.state.filterByCompletionDate,
            srDistrictIds: this.props.UserAuthentication?.UserInfo?.srDistrictIds,
            fromDate:
                this.state.startDate == null || this.state.startDate === ""
                    ? null
                    : Common.ConvertToUtcDateTimeNew(
                        Common.getOnlyDate(this.state.startDate) + " 00:00:00"
                    ),
            toDate:
                this.state.endDate == null || this.state.endDate === ""
                    ? null
                    : Common.ConvertToUtcDateTimeNew(
                        Common.getOnlyDate(this.state.endDate) + " 23:59:59"
                    ),
            provinceIdString,
            districtIdString,
            subrecipientId: subRecipientIdString,
            sortField: this.state.sortField,
            sortOrder: this.state[this.state.sortField + "sortOrder"],
        };
        // this.props.UserAuthentication?.UserInfo?.roleId === 1 || this.props.UserAuthentication?.UserInfo?.roleId === 7 ?
        // this.props.UserAuthentication?.UserInfo?.roleId === 6 ? Common.APILinks.Select_BHUAssignments : this.props.UserAuthentication?.UserInfo?.roleId === 7 ? Common.APILinks.Select_RHCAssignments :
        // Common.APILinks.Select_DestinationAssignments
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "Get",
            false,
            Common.APILinks.Select_AllAssignmentsDownload,
            Parameters,
            (resp) => {
                $("#FormSearchBtn").prop("disabled", false);
                this.setState({ loading: false });
                this.setState({
                    csvFileLink: Common.BaseUrlAPI + resp.csvFileLink,
                    exportLoading: false,
                });
                //$("#btnDownload").get(0).click();
            },
            (error) => {
                $("#FormSearchBtn").prop("disabled", false);
                this.setState({ loading: false });
                this.props.ShowAlert({
                    Type: 0,
                    Msg: "Something went wronge, please try again.",
                });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
            }
        );
    };
    PopulateTable = () => {
        $("#FormSearchBtn").prop("disabled", true);
        this.setState({ loading: true, data: [], TotalRecord: 0 });

        var provinceIdString =
            this.state.ProvinceId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.ProvinceId, "id") + ",";
        var districtIdString =
            this.state.DistrictId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.DistrictId, "id") + ",";
        var subRecipientIdString =
            this.state.SrId.length === 0
                ? ""
                : "," + Common.convertToCommaString(this.state.SrId, "id") + ",";

        var Parameters = {
            assignmentId: $("#SearchId").val(),
            RiderInfo: $("#SearchBy").val(),
            riderId: this.state.RiderId,
            rating: this.state.RatingId,
            statusId: this.state.StatusId,
            pageSize: this.state.sizePerPage,
            pageNumber: this.state.page,
            filterByCompletionDate: this.state.filterByCompletionDate,
            srDistrictIds: this.props.UserAuthentication?.UserInfo?.srDistrictIds,
            fromDate:
                this.state.startDate == null || this.state.startDate === ""
                    ? null
                    : Common.ConvertToUtcDateTimeNew(
                        Common.getOnlyDate(this.state.startDate) + " 00:00:00"
                    ),
            toDate:
                this.state.endDate == null || this.state.endDate === ""
                    ? null
                    : Common.ConvertToUtcDateTimeNew(
                        Common.getOnlyDate(this.state.endDate) + " 23:59:59"
                    ),
            provinceIdString,
            districtIdString,
            subrecipientId: subRecipientIdString,
            sortField: this.state.sortField,
            sortOrder: this.state[this.state.sortField + "sortOrder"],
        };
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "Get",
            false,
            Common.APILinks.Select_AllAssignments,
            Parameters,
            (resp) => {
                $("#FormSearchBtn").prop("disabled", false);
                if (resp.status) {
                    this.setState({ loading: false });
                    if (resp.data.length > 0) {
                        var ProcessedRider = Common.ProcessDataInArray(
                            this.state.Riderslist,
                            "id"
                        );
                        // var ProcessedProvince= Common.ProcessDataInArray(this.state.Provincelist,"id")
                        // var ProcessedDistrict= Common.ProcessDataInArray(this.state.Districtlist,"id")
                        for (var i in resp.data) {
                            // resp.data[i].provinceName = ProcessedProvince[resp.data[i].provinceId]?.name
                            // resp.data[i].districtName = ProcessedDistrict[resp.data[i].districtId]?.name
                            resp.data[i].RiderName =
                                resp.data[i]?.riderId == null ||
                                    resp.data[i]?.riderId === "" ||
                                    resp.data[i]?.riderId === 0
                                    ? ""
                                    : ProcessedRider[resp.data[i]?.riderId]?.name;
                            resp.data[i].RiderContact =
                                resp.data[i]?.riderId == null ||
                                    resp.data[i]?.riderId === "" ||
                                    resp.data[i]?.riderId === 0
                                    ? ""
                                    : ProcessedRider[resp.data[i]?.riderId]?.contact;
                        }
                    }
                    this.setState({
                        data: resp.data,
                        TotalRecord: resp.totalRecord,
                    });
                } else {
                    this.props.ShowAlert({ Type: 0, Msg: resp.message });
                    setTimeout(function () {
                        $("#Alertmsgbtn").click();
                    }, 50);
                }
            },
            (error) => {
                $("#FormSearchBtn").prop("disabled", false);
                this.setState({ loading: false });
                this.props.ShowAlert({
                    Type: 0,
                    Msg: "Something went wronge, please try again.",
                });
                setTimeout(function () {
                    $("#Alertmsgbtn").click();
                }, 50);
            }
        );
    };
    ResetRatingModel = (id) => {
        this.setState({
            rating: 0,
            assignmentId: id,
        });
        $("#Rider_Comments").val("");
        $(".Tag_item").removeClass("Tag_ActiveItem");
        $("#StarRatingModal_btn").click();
    };
    selectFeedbackTag = (e, val) => {
        if ($(e.target).hasClass("Tag_ActiveItem")) {
            $(e.target).removeClass("Tag_ActiveItem");
        } else {
            $(e.target).addClass("Tag_ActiveItem");
            var temp = $("#Rider_Comments").val();
            if (temp.indexOf(val) === -1) {
                temp = temp === "" || temp == null ? val : temp + ", " + val;
                $("#Rider_Comments").val(temp);
            }
        }
    };
    SaveRiderFeedBack = () => {
        this.props.ShowLoader({ Isloading: true });
        var Parameters = {
            starRating: this.state.rating,
            comments: $("#Rider_Comments").val(),
            assignmentId: this.state.assignmentId,
        };
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "Get",
            false,
            Common.APILinks.Save_RiderFeedback,
            Parameters,
            (resp) => {
                if (resp.status) {
                    this.setState({
                        rating: 0,
                        assignmentId: 0,
                    });
                    $("#Rider_Comments").val("");
                    $(".Tag_item").removeClass("Tag_ActiveItem");
                    this.props.ShowLoader({ Isloading: false });
                    this.props.ShowAlert({ Type: 1, Msg: "Saved successfully" });
                    setTimeout(() => {
                        $("#Alertmsgbtn").click();
                    }, 50);
                    this.PopulateTable();
                } else {
                    this.props.ShowLoader({ Isloading: false });
                    this.props.ShowAlert({ Type: 0, Msg: resp.message });
                    setTimeout(() => {
                        $("#Alertmsgbtn").click();
                    }, 50);
                }
            },
            (error) => {
                this.props.ShowLoader({ Isloading: false });
                this.props.ShowAlert({
                    Type: 0,
                    Msg: "Something went wronge, please try again.",
                });
                setTimeout(() => {
                    $("#Alertmsgbtn").click();
                }, 50);
            }
        );
    };
    ShowSampleStatusModal = (id) => {
        this.setState({
            SampleId: id,
            AFBId: 0,
        });
        $("#UpdateAfbStatusModal_btn").click();
    };
    RegenerateAssignment = (id) => {
        this.props.ShowLoader({ Isloading: true });
        var Parameters = {
            assignmentId: id,
        };
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "Get",
            false,
            Common.APILinks.ReActivate_Assignment,
            Parameters,
            (resp) => {
                if (resp.status) {
                    this.props.ShowLoader({ Isloading: false });
                    this.props.ShowAlert({
                        Type: 1,
                        Msg: "Job Re-Activated successfully",
                    });
                    setTimeout(() => {
                        $("#Alertmsgbtn").click();
                    }, 50);
                    this.PopulateTable();
                } else {
                    this.props.ShowLoader({ Isloading: false });
                    this.props.ShowAlert({ Type: 0, Msg: resp.message });
                    setTimeout(() => {
                        $("#Alertmsgbtn").click();
                    }, 50);
                }
            },
            (error) => {
                this.props.ShowLoader({ Isloading: false });
                this.props.ShowAlert({
                    Type: 0,
                    Msg: "Something went wronge, please try again.",
                });
                setTimeout(() => {
                    $("#Alertmsgbtn").click();
                }, 50);
            }
        );
    };
    onDelete = (id) => {
        this.setState(
            {
                alertModalData: {
                    title: "Delete Job",
                    message: "Are you sure you want to delete this record.",
                    First_Callback: () => {
                        $("#Generic-modal-CloseBtn").click();
                        this.DeleteRecord(id);
                    },
                    Second_Callback: () => {
                        $("#Generic-modal-CloseBtn").click();
                    },
                    type: 1,
                },
            },
            () => {
                $("#Show_ArletModal").click();
            }
        );
    };
    DeleteRecord = (id) => {
        this.props.ShowLoader({ Isloading: true });
        var Parameters = {
            assignmentId: id,
        };
        Common.Ajax(
            this.props.UserAuthentication.AuthToken,
            "Get",
            false,
            Common.APILinks.Delete_Assignment,
            Parameters,
            (resp) => {
                if (resp.status) {
                    this.PopulateTable();
                    this.props.ShowLoader({ Isloading: false });
                    this.props.ShowAlert({ Type: 1, Msg: "Deleted Successfully." });
                    setTimeout(function () {
                        $("#Alertmsgbtn").click();
                    }, 50);
                    // SyncConfig(()=>{},()=>{})
                } else {
                    this.props.ShowLoader({ Isloading: false });
                    this.props.ShowAlert({ Type: 0, Msg: resp.message });
                    setTimeout(() => {
                        $("#Alertmsgbtn").click();
                    }, 50);
                }
            },
            (error) => {
                this.props.ShowLoader({ Isloading: false });
                this.props.ShowAlert({
                    Type: 0,
                    Msg: "Something went wronge, please try again.",
                });
                setTimeout(() => {
                    $("#Alertmsgbtn").click();
                }, 50);
            }
        );
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Assignments_List);
